import React, { useState, useCallback, useEffect } from "react";
import { Image } from '@fluentui/react';
import {AppMenu} from "./AppMenu";


interface DemandManagementProps {}

interface DemandManagementState {}

const DemandManagement: React.FC<DemandManagementProps> = ({}) => {           
    const [pageState, setPageState] = useState<DemandManagementState>(() => {});

    return(
        <>
                            <div style={{width: "100%", textAlign: "left"}}>
                                <AppMenu/>
                            </div>
                            <div key={'DM1'} style={{ 
                            flex: '1 1 calc(100% - 40px)',
                            minWidth: '250px',
                            height: '530px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            overflow: 'hidden'
                          }}>
                            <div style={{ 
                              padding: '15px', 
                              borderBottom: '0px solid #e1e1e1',
                              background: '#ffffff',
                              fontWeight: 600,
                              color: '#323130'
                            }}>
                              Demand Management
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                               <div className="card-grey">         
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <div style={{  gap: '8px', letterSpacing: '0.02em', fontSize: '0.95rem' }}>Different factors are accounted for estimating demand starts from consumer behavior, economic environment to supply of goods and services. It is important to know what drives the demand and plan the stocks required to respond to the market fluctuations. eSDXG's Market research capability combined with process-assessed AI based demand planning and marketing execution helps businesses to optimize their performance.</div>
                                        <Image src="demandmanagement.png" alt="Demand Management" style={{ width: '450px', height: '350px', objectFit: 'scale-down' }} />
                                    </div>
                              </div>
                            </div>
                          </div>
                        </>
    );
}

export default DemandManagement; 
